import { createAsyncThunk, createSlice, isAnyOf } from '@reduxjs/toolkit';

import { errorNotification } from '../../components/notifications';
import api from '../../libs/api';

const initialState = {
  weeklyMisReport: null,
};

export const getWeeklyMisReport = createAsyncThunk(
  'weeklyMis/getWeeklyMisReport',
  async query => {
    const { data } = await api.get('/tasks/reports/weekly-mis', query);

    return data;
  },
);

const weeklyMis = createSlice({
  name: 'weeklyMis',

  initialState,

  reducers: {
    clearWeeklyMisReport: draft => {
      draft.weeklyMisReport = initialState.weeklyMisReport;
    },
  },

  extraReducers: builder => {
    builder.addCase(getWeeklyMisReport.fulfilled, (draft, { payload }) => {
      draft.weeklyMisReport = payload;
    });

    builder.addMatcher(
      isAnyOf(getWeeklyMisReport.rejected),
      (_draft, { error }) => {
        errorNotification(error);
      },
    );
  },
});

export const { clearWeeklyMisReport } = weeklyMis.actions;

export default weeklyMis.reducer;
